import type { SVGProps } from 'react';
const SvgWbSunny = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#wb_sunny_svg__a)">
      <path
        fill="currentColor"
        d="m6.76 4.84-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41ZM4 10.5H1v2h3v-2Zm9-9.95h-2V3.5h2V.55Zm7.45 3.91-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79Zm-3.21 13.7 1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4ZM20 10.5v2h3v-2h-3Zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Zm-1 16.95h2V19.5h-2v2.95Zm-7.45-3.91 1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8Z"
      />
    </g>
    <defs>
      <clipPath id="wb_sunny_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWbSunny;
